<template>
	<div
		id="page-container"
		class="sidebar-o enable-page-overlay side-scroll page-header-fixed page-header-classic main-content-narrow"
	>

		<!-- Side Overlay-->
      	<aside id="side-overlay">
	        <!-- Side Header -->
	        <div class="content-header">
	          <!-- Close Side Overlay -->
	          <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
	          <button type="button" class="btn btn-sm btn-outline-danger ms-auto" data-toggle="layout" data-action="side_overlay_close">
	            <i class="fa fa-fw fa-times"></i>
	          </button>
	          <!-- END Close Side Overlay -->
	        </div>
	        <!-- END Side Header -->

	        <!-- Emergency Notification -->
	        <div class="content-side content-side-full bg-info-light text-center">
	          <i class="fa fa-info-circle fa-2x text-info animated swing infinite"></i>
	          <p class="fs-5 fw-bold text-info mt-2 mb-0">
	            
	          </p>
	          <p>
	          	<div class="fs-xs text-muted mt-1"> ago</div>
	          </p>
	          <div class="fs-sm">
                <inertia-link class="fw-semibold text-info" data-toggle="layout" data-action="side_overlay_close">Click Here</inertia-link>
              </div>
	        </div>
	        <!-- END Emergency Notification -->

	        <!-- Side Content -->
	        <div class="content-side">

	          <!-- Notifications -->
	          <div class="block pull-x">
	            <div class="block-header bg-body-light">
	              <h3 class="block-title">Recent Updates</h3>
	              <div class="block-options">
	                <button @click="loadUpdates" type="button" class="btn-block-option" data-toggle="block-option" data-action="state_toggle" data-action-mode="demo">
	                  <i class="si si-refresh"></i>
	                </button>
	              </div>
	            </div>
	            <div class="block-content block-content-full">
	              
	              <a class="btn btn-alt-primary w-100" href="javascript:void(0)">
	                <i class="fa fa-flag opacity-50 me-1"></i>
	                View All Updates
	              </a>
	            </div>
	          </div>
	          <!-- END Notifications -->
	        </div>
	        <!-- END Side Content -->
      	</aside>
      	<!-- END Side Overlay -->

		<!-- Sidebar navigation -->
		<nav id="sidebar">
			<div class="sidebar-content">
				<div class="content-header justify-content-lg-center">
					<div>
						<span class="smini-visible fw-bold tracking-wide fs-lg">
							TRC<span class="text-primary">Portal</span>
						</span>
						<inertia-link class="fw-bold tracking-wide mx-auto" href="/">
							<span class="smini-hidden">
								<img
									src="/media/logo/trc-logo-title.png"
									alt="TRC Logo"
									style="height: 40px"
								/>
							</span>
						</inertia-link>
					</div>
					<div>
						<button
							type="button"
							class="btn btn-sm btn-outline-danger d-lg-none"
							data-toggle="layout"
							data-action="sidebar_close"
						>
							<i class="fa fa-fw fa-times"></i>
						</button>
					</div>
				</div>
				<!-- Sidebar content -->
				<sidebar
					:user="user"
					:user-role="userRole"
					:sidebar-menus="sidebarMenus"
					:my-communities="myCommunities"
					:communities-visited="communitiesVisited"
					:surveys="surveys"
					@toggle-survey="showSurveyModal"
				/>
			</div>
		</nav>
		<!-- Header -->
		<header id="page-header">
			<div class="content-header">
				<div class="space-x-1">
					<button
						type="button"
						class="btn btn-sm btn-alt-secondary"
						data-toggle="layout"
						data-action="sidebar_toggle"
					>
						<i class="fa fa-fw fa-bars"></i>
					</button>
					<!-- <button
						type="button"
						class="btn btn-sm btn-alt-secondary"
						data-toggle="layout"
						data-action="header_search_on"
					>
						<i class="fa fa-fw fa-search"></i>
					</button> -->
				</div>

				<div class="space-x-1 trc-logo-hidden">
					<span>
						<img
							src="/media/logo/trc-logo-title.png"
							alt="TRC Logo"
							style="height: 40px"
						/>
					</span>
				</div>
				<div class="space-x-1 trc-logo-hidden"></div>

				<div class="space-x-1 d-none d-sm-table-cell">

					<span v-if="userRole=='Member'" class="d-block ms-3 text-end" 
						:class="{
							'text-info':$page.props.rank_prefix=='S',
							'text-primary':$page.props.rank_prefix=='G',
							'text-warning':$page.props.rank_prefix=='D',
							'text-success':$page.props.rank_prefix=='P',
							'text-flat':$page.props.rank_prefix=='PC',
							'text-earth':$page.props.rank_prefix=='PF',
							'text-elegance':$page.props.rank_prefix=='B'
						}"
					>
						
						<span class="fs-xs fw-bold" :title="$page.props.user.current_rank+' Subscription'">
							<i class="fa fa-grip-horizontal"></i>
							Membership Level: {{$page.props.user.current_rank.toLowerCase().replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); })}}
							{{$page.props.user.add_alias.toLowerCase().replace(/\b[a-z]/g, function(letter) { return letter.toUpperCase(); })}}
						</span>
						
					</span>

					<div class="btn-group" :class="{'hide1':userRole!='Member'}" role="group">
		              <button type="button" class="btn btn-rounded btn-dual-secondary" id="page-header-notifications" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
		                <i class="fa fa-bell me-1" :class="{'text-danger tada animated infinite':$page.props.notifications.total_unread>0}"></i>
		                <span class="badge" :class="{'bg-danger':$page.props.notifications.total_unread>0,'bg-secondary':$page.props.notifications.total_unread<=0}">{{$page.props.notifications.total_unread}}</span>
		              </button>
		              <div class="dropdown-menu dropdown-menu-right min-width-300 p-0" aria-labelledby="page-header-notifications" style="">
		                <p class="fs-sm fw-semibold text-center py-2 mb-0 border-bottom text-uppercase">Notifications</p>
	               	 	<div>
	               	 		<a @click="readNotification(n_index)" v-for="(notify,n_index) in $page.props.notifications.notifications" class="dropdown-item1 dropdown-item media" :class="{'notify-unread':notify.is_read==0}" href="javascript:void(0)">
		                      <span class="me-2">
		                        <i v-if="['insurance-verified'].includes(notify.data.type)" class="fa fa-fw fa-check text-success"></i>
		                        <i v-if="['insurance-rejected'].includes(notify.data.type)" class="fa fa-fw fa-times text-danger"></i>
		                        <i v-if="['Events','Zoom'].includes(notify.data.loc)" class="fa fa-fw fa-calendar-alt text-primary"></i>
		                        <i v-if="['Video Library'].includes(notify.data.loc)" class="fa fa-fw fa-video text-warning"></i>
		                        <i v-if="['Updates'].includes(notify.data.loc)" class="fa fa-fw fa-tag text-info"></i>
		                      </span>
		                      <span class="media-body pr-10">
		                        <p class="mb-0 fs-xs fw-bold"><span>{{notify.data.title}}</span></p>
		                        <p class="mb-0"><sub>{{notify.data.short_desc}}</sub></p>
		                        <div class="text-muted fs-xs font-italic mt-1">{{notify.date_short}} ago</div>
		                      </span>
		                    </a>
		                    <p v-if="$page.props.notifications.notifications.length==0" class="content text-center mb-4 text-danger">No Notifications Found</p>
	               	 	</div>
		                <div class="dropdown-divider m-0"></div>
		                <inertia-link v-if="$page.props.notifications.view_more=='Yes'" class="dropdown-item text-center mb-0" href="/member/notifications/unread">
		                  <i class="fa fa-bell me-2"></i> View All
		                </inertia-link>
		              </div>
		            </div>

		            <span v-if="userRole=='Community'" class="d-inline-block ms-3">
			            <inertia-link href="/member/community/post/create" class="fs-xs btn btn-outline-info"><i class="fa fa-plus me-2"></i>Create</inertia-link>
					</span>

					<div v-if="userRole=='Community'" class="btn-group" role="group">
		              <button type="button" class="btn btn-rounded btn-dual-secondary" id="page-header-notifications" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
		                <i class="fa fa-bell me-1" :class="{'text-danger tada animated infinite':$page.props.notifications.total_unread>0}"></i>
		                <span class="badge" :class="{'bg-danger':$page.props.notifications.total_unread>0,'bg-secondary':$page.props.notifications.total_unread<=0}">{{$page.props.notifications.total_unread}}</span>
		              </button>
		              <div class="dropdown-menu dropdown-menu-right min-width-300 p-0" aria-labelledby="page-header-notifications" style="">
		                <p class="fs-sm fw-semibold text-center py-2 mb-0 border-bottom text-uppercase">Notifications</p>
	               	 	<div>
	               	 		<a @click="readNotification(n_index)" v-for="(notify,n_index) in $page.props.notifications.notifications" class="dropdown-item1 dropdown-item media" :class="{'notify-unread':notify.is_read==0}" href="javascript:void(0)">
		                      <span class="me-2">
		                        <i v-if="['insurance-verified'].includes(notify.data.type)" class="fa fa-fw fa-check text-success"></i>
		                        <i v-if="['insurance-rejected'].includes(notify.data.type)" class="fa fa-fw fa-times text-danger"></i>
		                        <i v-if="['Events','Zoom'].includes(notify.data.loc)" class="fa fa-fw fa-calendar-alt text-primary"></i>
		                        <i v-if="['Video Library'].includes(notify.data.loc)" class="fa fa-fw fa-video text-warning"></i>
		                        <i v-if="['Updates'].includes(notify.data.loc)" class="fa fa-fw fa-tag text-info"></i>
		                      </span>
		                      <span class="media-body pr-10">
		                        <p class="mb-0 fs-xs fw-bold"><span>{{notify.data.title}}</span></p>
		                        <p class="mb-0"><sub>{{notify.data.short_desc}}</sub></p>
		                        <div class="text-muted fs-xs font-italic mt-1">{{notify.date_short}} ago</div>
		                      </span>
		                    </a>
		                    <p v-if="$page.props.notifications.notifications.length==0" class="content text-center mb-4 text-danger">No Notifications Found</p>
	               	 	</div>
		                <div class="dropdown-divider m-0"></div>
		                <inertia-link v-if="$page.props.notifications.view_more=='Yes'" class="dropdown-item text-center mb-0" href="/member/notifications/unread">
		                  <i class="fa fa-bell me-2"></i> View All
		                </inertia-link>
		              </div>
		            </div>

					<div class="dropdown d-inline-block">
						<button
							type="button"
							class="btn btn-sm btn-alt-secondary"
							id="page-header-user-dropdown"
							data-bs-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false"
						>
							<span class="fw-semibold text-uppercase">
								{{ $page.props.user.fname }}
							</span>
							<i class="fa fa-angle-down opacity-50 ms-1"></i>
						</button>
						<div
							class="dropdown-menu dropdown-menu-md dropdown-menu-end p-0"
							aria-labelledby="page-header-user-dropdown"
						>
							<div class="p-2">
								<inertia-link
									class="dropdown-item d-flex align-items-center justify-content-between space-x-1"
									href="/member/profile"
								>
									<span>Profile</span>
									<i class="fa fa-fw fa-user opacity-25"></i>
								</inertia-link>
								<inertia-link v-if="userRole=='Member'"
									class="dropdown-item d-flex align-items-center justify-content-between space-x-1"
									href="/member/plan-details"
								>
									<span>Plan Details</span>
									<i class="fa fa-fw fa-list opacity-25"></i>
								</inertia-link>
								<inertia-link v-if="userRole=='Admin'"
									class="dropdown-item d-flex align-items-center justify-content-between space-x-1"
									href="/reset-password"
								>
									<span>Change Password</span>
									<i class="fa fa-fw fa-key opacity-25"></i>
								</inertia-link>
								<div class="dropdown-divider"></div>
								<inertia-link
									class="dropdown-item d-flex align-items-center justify-content-between space-x-1"
									:href="'/post/log-out?role='+userRole.toLowerCase()"
									method="POST"
									as="button"
								>
									<span>Sign Out</span>
									<i class="fa fa-fw fa-sign-out-alt opacity-25"></i>
								</inertia-link>
							</div>
						</div>
					</div>

					<!-- Toggle Side Overlay -->
		            <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
		            <!-- <button type="button" class="btn btn-rounded btn-dual-secondary" :class="{'show1':userRole=='Member','hide1':userRole=='BCC'}" data-toggle="layout" data-action="side_overlay_toggle">
		              <span class="badge animated swing infinite">
		                <i class="fa fa-fw fa-info-circle text-info fa-2x"></i>
		              </span>
		            </button> -->
		            <!-- END Toggle Side Overlay -->
		            <span v-if="userRole=='Member'" class="d-inline-block ms-3">
			            <div v-if="!['PLATINUM COUPLE','PLATINUM FAITHFUL','FREE'].includes($page.props.user.current_rank)">
							<inertia-link href="/member/upgrade" class="fs-xs btn btn-danger"><i class="fa fa-arrow-circle-up me-2"></i>Upgrade your Membership</inertia-link>
						</div>
					</span>
				</div>

			</div>

			<div id="page-header-search" class="overlay-header bg-body-extra-light">
				<div class="content-header">
					<form class="w-100">
						<div class="input-group">
							<button
								type="button"
								class="btn btn-secondary"
								data-toggle="layout"
								data-action="header_search_off"
							>
								<i class="fa fa-fw fa-times"></i>
							</button>
							<input
								type="text"
								class="form-control"
								placeholder="Search or hit ESC.."
								id="page-header-search-input"
								name="page-header-search-input"
							/>
							<button type="submit" class="btn btn-secondary">
								<i class="fa fa-fw fa-search"></i>
							</button>
						</div>
					</form>
				</div>
			</div>
			<div id="page-header-loader" class="overlay-header bg-primary">
				<div class="content-header">
					<div class="w-100 text-center">
						<i class="far fa-sun fa-spin text-white"></i>
					</div>
				</div>
			</div>
		</header>
		<!-- Main container -->
		<main id="main-container">
			<slot></slot>

			<modal ref="surveyModal">
				<template #title>WE'D LOVE TO HEAR FROM YOU</template>
				<template #body>
					<div v-if="surveys.length>0" class="row">
						<div v-if="errors.hasOwnProperty('survey_rate')">
							<div class="text-danger text-center mb-3 fw-bold">The survey rates are required.</div>
						</div>
						<div v-for="(survey, sindex) in surveys" class="col-12 mb-1">
							<div class="row mb-4">
								<div class="col-8 fw-bold">
									{{survey.survey_question}}
									
								</div>
								<div class="col-4 text-end">
									<span :id="'survey_star-'+sindex" v-for="cnt in survey.survey_rate" @click="rateSurvey(sindex,survey.survey_item_uuid,cnt)" class="fa fa-fw fa-star" style="cursor:pointer;"></span>
								</div>
							</div>
						</div>
						<div class="col-12 mb-1">
							Please share any additional thoughts or suggestions you have for improving our site.
							<div>
								<textarea v-model="formSurvey.survey_comment" rows="4" class="form-control"></textarea>
							</div>
						</div>
					</div>
				</template>
				<template #footer>
					<button @click="surveyModal.toggleModal" type="button" class="text-start btn btn-alt-secondary" :disabled="formSurvey.processing">
						<i class="fa fa-times me-1"></i>Cancel
					</button>
					<button @click="submitSurvey" type="button" class="text-end btn btn-alt-success" :disabled="formSurvey.processing">
						<div
							v-if="formSurvey.processing"
							class="spinner-border spinner-border-sm text-dark me-1"
							role="status"
						>
							<span class="sr-only">Loading...</span>
						</div>
						<i v-else class="fa fa-save me-1"></i>
						<span>Submit</span>
					</button>
				</template>
			</modal>

		</main>
		<!-- Footer -->
		<footer id="page-footer">
			<div class="content py-3">
				<div class="row fs-sm">
					<div class="col-sm-12 order-sm-1 py-1 text-center">
						<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
						&copy; <span data-toggle="year-copy"></span>
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>

<script setup>
import { onMounted, watch, ref } from 'vue'
import Sidebar from './Sidebar/Index'
import { useForm, usePage } from '@inertiajs/inertia-vue3'
import { createToaster } from '@meforma/vue-toaster'
import { Inertia } from '@inertiajs/inertia';

const props = defineProps({
	flash: Object,
	errors: Object,
	user: Object,
	userRole: String,
	sidebarMenus: Object,
	myCommunities: Object,
	communitiesVisited: Object,
	surveys: Object,
})

const toast = createToaster();

const formSurvey = useForm({
	survey_list_uuid 	: props.surveys.length > 0 ? props.surveys[0].survey_list_uuid : null,
	prod_id 			: null,
	survey_data 		: [],
	survey_comment		: ''
});


if(props.surveys.length>0)
{
	formSurvey.survey_data = [];

	for(var i=0; i < props.surveys.length;i++){
		let survey = props.surveys[i];
		formSurvey.survey_data.push({
			survey_item_uuid : survey.survey_item_uuid,
			survey_rate : 0
		});
	}
}

const surveyModal 			= ref(null);


const showSurveyModal = ()=>{
	surveyModal.value.toggleModal();
}


const formChecklist = useForm({
	checklist_id 	: null,
	checklist_name 	: null,
	is_done 		: 0,
})

const rateSurvey = (sindex,survey_item_uuid,survey_rate)=>{

	$("span#survey_star-"+sindex).removeClass("text-warning");

	formSurvey.survey_data[sindex].survey_item_uuid = survey_item_uuid;
	formSurvey.survey_data[sindex].survey_rate 		= survey_rate;

	for(var i=0; i < survey_rate; i++){
		$("span#survey_star-"+sindex+":eq("+i+")").addClass("text-warning");
	}
	
}

const submitSurvey = ()=>{

	formSurvey.post(route('member.post.store_survey'), {
					preserveState: true,
					preserveScroll: true,
					only: ['surveys','flash','errors'],
					onSuccess:()=>{
						if(props.flash.toast.type=="success"){
							surveyModal.value.toggleModal();
							formSurvey.survey_data = [];
						}
					}
				})
}


const readNotification = (_index)=>{
	var notification = usePage().props.value.notifications.notifications[_index];
	var id = notification.id;
	var notify_link = notification.data.link;

	axios.get('/api/read/notification/'+id)
	   	.then(res => {
	      if(res.data.result=="success")
	      {
	      	Inertia.visit(notify_link,{ method: 'get' });
	      }else
	      {
	      	console.log("Failed");
	      }
	   	})
}

const loadUpdates = ()=>{
	Inertia.reload({
		preserveState: true,
		preserveScroll: true
	})
}

watch(
	() => props.surveys,
	(surveys) => {
		if(surveys.length>0)
		{
			if(formSurvey.survey_data.length==0)
			{
				formSurvey.survey_data = [];

				for(var i=0; i < surveys.length;i++){
					let survey = surveys[i];
					formSurvey.survey_data.push({
						survey_item_uuid : survey.survey_item_uuid,
						survey_rate : 0
					});
				}
			}
		}
	}
)

watch(
	() => props.flash,
	(flash) => {
		if (flash && flash.toast && flash.toast.type!="default") {
			toast.show(flash.toast.msg, { type: flash.toast.type})
		}
	}
)
</script>
